import { useIntl } from 'react-intl';
import DeleteUser from '../../../../assets/delete_user.webp';
import { CounterList } from '../CounterList';

export const DeleteUserExplained = () => {
    const intl = useIntl();

    const title = intl.formatMessage({ id: 'intl-msg:infoDialog.functions.deleteUser.headline' });

    return (
        <div className={'row'} data-testid={'Create User'}>
            <div className={'col-xs-12'}>
                <h4>{title}</h4>
                <div className={'margin-bottom-25'}>
                    <img src={DeleteUser} alt={'tdv'} className={'max-width-75pct'} />
                </div>
                <CounterList chapter={'deleteUser'} count={2} />
            </div>
        </div>
    );
};
